import { targets } from './actions';
import { addToPrintQueue, markOrderAsPrinted } from './printQueue';

export const updateOrderByPusher = (state, action) => {
  const { orders } = state;
  const pusherOrder = action.payload;
  const updatedOrders = orders?.list
    ? orders.list.map((order) =>
        order.id === pusherOrder.id ? { ...order, status: pusherOrder.status } : order
      )
    : [];
  // merge replaces the orders object wholesale, so it has to carry the pagination forward.
  return state.merge({
    [targets.ORDERS]: {
      ...orders,
      list: updatedOrders
    }
  });
};

export const addOrderToPrintQueue = (state, action) => {
  const { print, printedOrderIds } = state;
  // clonado profundo: la comanda impresa queda congelada al momento de aceptar (MS-3940, MS-4017)
  const order = JSON.parse(JSON.stringify(action.payload));
  const nextState = addToPrintQueue(print, printedOrderIds, order);

  return nextState ? state.merge(nextState) : null;
};

export const removeOrderPrintQueue = (state, action) => {
  const { print, printedOrderIds } = state;
  const nextState = markOrderAsPrinted(print, printedOrderIds, action.payload);

  return nextState ? state.merge(nextState) : null;
};
